const SURVEY_FIELD_TYPES = ['text', 'number', 'date'] as const;

export function validateSurveyFieldName(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.trim()) return 'Field name is required';
  return undefined;
}

export function validateSurveyFieldType(value: unknown): string | undefined {
  if (typeof value !== 'string' || !SURVEY_FIELD_TYPES.includes(value as any)) {
    return `Field type must be one of: ${SURVEY_FIELD_TYPES.join(', ')}`;
  }
  return undefined;
}
